import axios from "axios";
import store from "store";
import { setTokenExpired } from "../Redux/authSlice";
import authService from "./auth.service";

const api_direct = axios.create({
  baseURL: process.env.REACT_APP_DEFAULT_ENDPOINT.replace(/proxy/g, ""),
  headers: {
    Authorization: `Bearer ${process.env.REACT_APP_TOKEN}`,
  },
  params: {
    fromChannel: process.env.REACT_APP_DEFAULT_CHANNEL,
  },
});

api_direct.interceptors.request.use(
  async (config) => {
    try {
      const needsOAuthToken = config.headers?.["X-Needs-OAuth"] === true;
      const hasOAuthToken = authService.getAccessToken();
      
      if (needsOAuthToken || hasOAuthToken) {
        if (needsOAuthToken) {
          delete config.headers["X-Needs-OAuth"];
        }
        
        const token = await authService.ensureValidToken();
        config.headers.Authorization = `Bearer ${token}`;
        
        store.dispatch(setTokenExpired(false));
      }

      return config;
    } catch (error) {
      console.error("Erro ao preparar requisição:", error);
      if (error.response?.status === 401) {
        store.dispatch(setTokenExpired(true));
      }
      return Promise.reject(error);
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

api_direct.interceptors.response.use(
  (response) => {
    return response;
  },
  async function (error) {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const newToken = await authService.refreshToken();
        
        originalRequest.headers.Authorization = `Bearer ${newToken}`;
        
        return api_direct(originalRequest);
      } catch (refreshError) {
        console.error("Erro ao renovar token:", refreshError);
        store.dispatch(setTokenExpired(true));
        
        if (window.location.protocol === "llwl:") {
          window.location = "llwl://fail?reason=jwt_invalido";
        }
        
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default api_direct;
